import type { NavigateLink } from '@/components/navigate/NavigateLinks';
import { useMemo, useCallback } from 'react';
import { NavigateLinks } from '@/components';
import { monitoringPageBreadcrumbs } from './config';
import { RouteSearchBar, RouteList } from './components';
import { useRoutesFilter, useRoutesPagination } from './hooks';
import { useNavigate } from 'react-router-dom';
import type { RoutesFilter } from './models';

export interface MonitoringProps {
  breadcrumbs?: NavigateLink[];
}

const Monitoring = ({ breadcrumbs: breadcrumbsProp }: MonitoringProps = {}) => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => breadcrumbsProp ?? monitoringPageBreadcrumbs(navigate),
    [navigate, breadcrumbsProp]
  );
  const {
    filters,
    setFilters,
    mergeRoutesFilter: mergeRoutesFilterState,
    initialFilter,
  } = useRoutesFilter();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useRoutesPagination();

  const mergeRoutesFilter = useCallback(
    (partialRoutesFilter: Partial<RoutesFilter>) => {
      mergeRoutesFilterState(partialRoutesFilter);
      handlePageChange(1);
    },
    [mergeRoutesFilterState, handlePageChange]
  );

  const applyRouteFilters = useCallback(
    (appliedRoutesFilter: RoutesFilter) => {
      setFilters(appliedRoutesFilter);
      handlePageChange(1);
    },
    [setFilters, handlePageChange]
  );

  return (
    <section className='flex flex-col gap-3 w-full h-full min-h-0'>
      <NavigateLinks actualPage='Gestión de Rutas' breadcrumbs={breadcrumbs} />
      <RouteSearchBar
        initialFilter={initialFilter}
        filter={filters}
        search={applyRouteFilters}
        mergeRoutesFilter={mergeRoutesFilter}
      />
      <RouteList
        filter={filters}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </section>
  );
};

export default Monitoring;
